import Box from '@mui/material/Box';
import { HERO_IMAGE } from './hero.constants';
import { HeroFireworks } from './HeroFireworks';

export function HeroBackground() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        bgcolor: '#0A1433',
      }}
    >
      <Box
        component="img"
        src={HERO_IMAGE}
        alt=""
        decoding="async"
        fetchPriority="high"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          // Keep the Aarti priests and temples in frame on narrow screens.
          objectPosition: { xs: '78% center', md: 'center center' },
          display: 'block',
        }}
      />

      {/* Deep navy / royal blue wash — strong on the left for copy, clear over the Aarti */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: {
            xs: `linear-gradient(
              180deg,
              rgba(6, 12, 36, 0.78) 0%,
              rgba(10, 22, 64, 0.62) 50%,
              rgba(6, 12, 36, 0.55) 100%
            )`,
            md: `linear-gradient(
              100deg,
              rgba(6, 12, 36, 0.9) 0%,
              rgba(12, 26, 78, 0.74) 30%,
              rgba(20, 40, 110, 0.4) 52%,
              rgba(20, 40, 110, 0.1) 70%,
              rgba(6, 12, 36, 0) 100%
            )`,
          },
          pointerEvents: 'none',
        }}
      />

      <HeroFireworks />

      {/* Top vignette for navbar legibility */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 120,
          background: 'linear-gradient(to bottom, rgba(6, 12, 36, 0.5) 0%, transparent 100%)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}
